import { h } from "@stencil/core";
import { BEM } from "../../../utils/bem";
export const OverviewLink = ({ item, isMenu, onClick, isVisible }) => {
    const block = BEM.block('nav');
    if (!item) {
        return '';
    }
    return (h("a", { class: Object.assign(Object.assign(Object.assign({}, block.element('mobile-overview-link').class()), block.element('mobile-overview-link').modifier('menu').class(!!isMenu)), block
            .element('mobile-overview-link')
            .modifier('invisible')
            .class(isVisible === false)), href: item.href, target: item.target, onClick: ev => onClick(ev) }, item.label, " ", item.label ? '➞' : ''));
};
